import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import Navbar from './Navbar';
import HeroSectionTailwind from './HeroSectionTailwind';
import AboutSection from './AboutSection';
import BlogSection from './BlogSection';
import ContactSection from './ContactSection';
import Footer from './Footer';
import ScrollIndicator from './ScrollIndicator';

const HomePage = () => {
    const {i18n, t} = useTranslation();

    // Web3Forms access key — get yours free at https://web3forms.com (enter info@dietsarakhedr.com).
    // It is safe to expose this key in the frontend; that is how Web3Forms is designed to work.
    const WEB3FORMS_ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY || 'eff607d6-0198-427a-bf88-f7c1a78f18db';

    const [form, setForm] = useState({name: '', email: '', phone: '', interest: '', message: ''});
    const [submitting, setSubmitting] = useState(false);
    const [notification, setNotification] = useState(null);

    const handleFormChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setNotification(null);
        try {
            const response = await fetch('https://api.web3forms.com/submit', {
                method: 'POST',
                headers: {'Content-Type': 'application/json', Accept: 'application/json'},
                body: JSON.stringify({
                    access_key: WEB3FORMS_ACCESS_KEY,
                    subject: `New contact form message from ${form.name || 'website visitor'}`,
                    from_name: 'Sara Khedr Website',
                    name: form.name,
                    email: form.email,
                    phone: form.phone,
                    interest: form.interest,
                    message: form.message,
                    language: i18n.language,
                    botcheck: form.botcheck, // honeypot, stays empty for real users
                }),
            });
            const result = await response.json();
            if (result.success) {
                setNotification({type: 'success', message: t('form-success')});
                setForm({name: '', email: '', phone: '', interest: '', message: ''});
            } else {
                setNotification({type: 'error', message: t('form-error')});
            }
        } catch (err) {
            setNotification({type: 'error', message: t('form-error')});
        } finally {
            setSubmitting(false);
        }
    };

    // Language switcher
    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);
    };

    // Smooth scrolling is handled globally via CSS (scroll-behavior + scroll-padding-top in theme.css)

    return (
        <div>
            {/* Navbar */}
            <Navbar t={t} i18n={i18n} handleLanguageChange={handleLanguageChange}/>

            {/* Scroll Indicator */}
            <ScrollIndicator/>

            {/* Hero Section */}
            <HeroSectionTailwind t={t}/>

            {/* About Section */}
            <AboutSection t={t}/>

            {/*/!* Plans & Consultations Section *!/*/}
            {/*<PlansSection t={t} />*/}

            {/* Blog Section */}
            <BlogSection/>

            {/* Contact Section */}
            <ContactSection t={t} form={form} handleFormChange={handleFormChange} handleFormSubmit={handleFormSubmit}
                            submitting={submitting} notification={notification}/>

            {/* Footer */}
            <Footer t={t}/>
        </div>
    );
};

export default HomePage;
